/**
 * B2B sklep — przełącznik grid/lista (localStorage) + ajax add-to-cart z ilością.
 * No-op gdy brak .hn-shop-view-toggle (B2C / nie-sklep).
 */
export function initShopList() {
    const toggle = document.querySelector('.hn-shop-view-toggle');
    const container = document.querySelector('.hn-products');
    if (!toggle || !container) return;

    const KEY = 'hn_shop_view';
    const apply = (view) => {
        const isList = view === 'list';
        container.classList.toggle('hn-products--list', isList);
        container.classList.toggle('hn-products--grid', !isList);
        toggle.querySelectorAll('[data-view]').forEach((b) =>
            b.setAttribute('aria-pressed', String(b.dataset.view === view)));
    };
    apply(localStorage.getItem(KEY) === 'list' ? 'list' : 'grid');

    toggle.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-view]');
        if (!btn) return;
        localStorage.setItem(KEY, btn.dataset.view);
        apply(btn.dataset.view);
    });

    container.addEventListener('click', (e) => {
        const add = e.target.closest('.hn-list-add');
        if (!add) return;
        e.preventDefault();
        const row = add.closest('.hn-product-card');
        const qtyInput = row && row.querySelector('.hn-list-qty');
        // Uszanuj regułę ilości B2BKing z inputu (min + krok/wielokrotność, np. 6).
        const step = Math.max(1, parseInt((qtyInput && qtyInput.step) || '1', 10) || 1);
        const min = Math.max(1, parseInt((qtyInput && qtyInput.min) || '1', 10) || 1);
        let qty = Math.max(min, parseInt((qtyInput && qtyInput.value) || String(min), 10) || min);
        if (step > 1 && qty % step !== 0) qty = Math.ceil(qty / step) * step; // dosuń do wielokrotności
        if (qtyInput && String(qty) !== qtyInput.value) qtyInput.value = String(qty); // odzwierciedl korektę
        // Dla wariantów: wybrany variation_id (WC add_to_cart wykryje typ variation z product_id).
        const variation = row && row.querySelector('.hn-list-variation');
        const pid = (variation && variation.value) ? variation.value : add.dataset.product_id;
        if (!pid) return;

        add.classList.add('is-loading');
        const body = new URLSearchParams({ product_id: pid, quantity: String(qty) });
        fetch('/?wc-ajax=add_to_cart', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body,
            credentials: 'same-origin',
        })
            .then((r) => r.json())
            .then((data) => {
                if (data && data.error && data.product_url) { window.location = data.product_url; return; }
                if (window.jQuery) {
                    window.jQuery(document.body).trigger('added_to_cart', [data.fragments, data.cart_hash, window.jQuery(add)]);
                } else {
                    document.body.dispatchEvent(new CustomEvent('wc_fragment_refresh'));
                }
            })
            .catch(() => {})
            .finally(() => { add.classList.remove('is-loading'); });
    });

    // Zmiana wariantu → aktualizuj wyświetlaną cenę netto/brutto.
    container.addEventListener('change', (e) => {
        const sel = e.target.closest('.hn-list-variation');
        if (!sel) return;
        const opt = sel.selectedOptions[0];
        const row = sel.closest('.hn-product-card');
        if (!opt || !row) return;
        const netAmt = row.querySelector('.hn-list-price__net .hn-amt');
        const grossAmt = row.querySelector('.hn-list-price__gross .hn-amt');
        if (netAmt && opt.dataset.net) netAmt.innerHTML = opt.dataset.net;
        if (grossAmt && opt.dataset.gross) grossAmt.innerHTML = opt.dataset.gross;
        const eanEl = row.querySelector('.hn-product-card__ean');
        if (eanEl) {
            const eanVal = eanEl.querySelector('.hn-ean-val');
            if (opt.dataset.ean) { if (eanVal) eanVal.textContent = opt.dataset.ean; eanEl.style.display = ''; }
            else { eanEl.style.display = 'none'; }
        }
    });
}
